import { render, staticRenderFns } from "./AboutFour.vue?vue&type=template&id=08358239&scoped=true&"
import script from "./AboutFour.vue?vue&type=script&lang=js&"
export * from "./AboutFour.vue?vue&type=script&lang=js&"
import style0 from "./AboutFour.vue?vue&type=style&index=0&id=08358239&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08358239",
  null
  
)

export default component.exports